import API from './index';
import AppUrls from '../config/AppUrls';
import { buildPathWithParams } from '../utils/Paths';

class TicketsService {
  static fetchLastTickets(limit) {
    return API.get(AppUrls.api.ticketsSummary, { limit }).then((response) => response.data);
  }

  static fetchTickets(filters) {
    return API.get(AppUrls.api.tickets, filters).then((response) => response.data);
  }

  static fetchTicketsTypes() {
    return API.get(AppUrls.api.ticketsTypes).then((response) => response.data);
  }

  static fetchTicketDetails(idTicket) {
    const path = buildPathWithParams(AppUrls.api.ticketDetails, { idTicket });
    return API.get(path).then((response) => response.data);
  }

  static createTicket() {
    return API.post(AppUrls.api.createTicket).then((response) => response.data);
  }

  static addTicketAttachment(idTicket, file, title) {
    const path = buildPathWithParams(AppUrls.api.addTicketAttachment, { idTicket });
    return API.post(path, { file, title }).then((response) => response.data);
  }

  static removeTicketAttachment(idAttachment) {
    return API.delete(buildPathWithParams(AppUrls.api.removeTicketAttachment, { idAttachment })).then((response) => response.data);
  }

  static getTicketAttachment(idAttachment) {
    return API.get(buildPathWithParams(AppUrls.api.getTicketAttachment, { idAttachment })).then((response) => response.data);
  }

  static cancelTicket(idTicket) {
    const path = buildPathWithParams(AppUrls.api.cancelTicket, { idTicket });
    return API.delete(path, { idTicket }).then((response) => response.data);
  }

  static confirmTicket(idTicket, content, beneficiary, documentType, document, bank, bankBranch, accountType, accountNumber, genericTicketType, isSupport=false) {
    const path = buildPathWithParams(AppUrls.api.confirmTicket, { idTicket });
    if(isSupport) {
      return API.post(path, { idTicket, content, beneficiary, documentType, document, bank, bankBranch, accountType, accountNumber, genericTicketType }).then((response) => response.data);
    } else {
      return API.post(path, { idTicket, content, beneficiary, documentType, document, bank, bankBranch, accountType, accountNumber }).then((response) => response.data);
    }
  }

  static closeTicket(idTicket) {
    const path = buildPathWithParams(AppUrls.api.closeTicket, { idTicket });
    return API.post(path, { idTicket }).then((response) => response.data);
  }

  static closeMultipleTickets(idTickets) {
    return API.post(AppUrls.api.closeMultipleTickets, idTickets).then((response) => response.data);
  }
}

export default TicketsService;
